import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputTextSF from '../../../widgets/form/InputTextSF'

const PhoneNumberUpdateModalUI = ({ context, successMsg, errorList, setErrorList,
  // modes
  updateMode, submitted,
  // event handlers
  onSubmit, onCancelClick,
  // form fields
  phoneNumber, onPhoneNumberChange, phoneNumberError, setPhoneNumberError
}) =>
  <ModalFormUI
    context={context}
    titleLabel='Update phone number'
    buttonLabel='Update'
    cancelLabel='Cancel'
    isOpen={updateMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    <InputTextSF
      type="positive_integer" 
      name="phoneNumber" 
      label="Phone Number"
      required={true} 
      value={phoneNumber}
      maxLength={10}
      onChange={onPhoneNumberChange} 
      error={phoneNumberError} 
      setError={setPhoneNumberError}
      autoFocus={true}
    />
  </ModalFormUI>

export default PhoneNumberUpdateModalUI
